function decodePagination(data = {}) {
  return {
    currentPage: data.current_page,
    hasNextPage: !!data.has_next_page,
    lastPage: data.last_page,
    perPage: data.per_page,
    total: data.total
  };
}

export default decodePagination;
